<script setup lang="ts">
const query = ref('');

const emit = defineEmits<{
  search: [query: string];
}>();

const onSearch = async () => {
  if (!query.value.trim()) return;
  emit('search', query.value);
};
</script>

<template>
  <div class="mb-10">
    <TypographyTitle as="h2" size="lg" class="mb-6">Ask a Question</TypographyTitle>
    <p class="mb-4">Search BRUIN Support for help articles.</p>

    <div class="flex gap-4">
      <input
        v-model="query"
        type="text"
        placeholder="Search our Knowledgebase"
        class="w-full border bg-white px-2"
        @keyup.enter="onSearch"
      />
      <BaseButton @click="onSearch">SEARCH</BaseButton>
    </div>
  </div>
</template>
